import { Paper, Container} from "@mui/material";
import { FooterStyles as styles } from "./Footer.styles";

export default function Footer({ children }) {
  return (
    <Paper sx={styles} component="footer" square variant="outlined">
      <Container maxWidth="lg">
        {children}
      </Container>
    </Paper>
  );
}
